<template>
    <div>
        <transition name="fade">
            <div v-if="dataLoadingInStoreStatus" class="loading">
                <p>Loading..</p>
            </div>
        </transition>

        <transition name="fade">
            <div v-if="gettingBuyersList" class="loading">
                <p>Getting Buyers List..</p>
            </div>
        </transition>

        <b-container>
            <hr>
            <b-row>
                <h1 style="padding:20px">Welcome Back</h1>
            </b-row>

            <!-- Two column layout for desktop, one column for mobile -->
            <b-row>
                <b-col md='6'>
                    <h2>Actions Needed</h2>
                    <b-button block variant="primary" @click="showOrders()">{{newBreweryOrdersCount }} New Orders <b-badge variant="light" v-if='newBreweryOrdersCount'>{{newBreweryOrdersCount}}</b-badge></b-button>
                    <!-- New Orders -->
                    <!-- Messages -->
                    <b-button block variant="success" @click="showMessages()">{{unreadCount }} New Messages <b-badge  variant="light" v-if='unreadCount'>{{unreadCount}}</b-badge></b-button>
                    <!-- Awaiting Delivery -->
                    <b-button block variant="warning" @click="showOrders()">{{deliverSoonCount }} Orders To Be Delivered Soon</b-button>
                    <!-- Service Requests -->
                    <b-button block variant="info" @click="showServiceRequests()">{{openServiceRequests}} Service Requests <b-badge  variant="light" v-if='openServiceRequests'>{{openServiceRequests}}</b-badge></b-button>

                    <!-- Inventory -->
                    <b-row>
                        <b-col>
                            <div style="text-align:center; margin-top:20px">
                                <b-button size="lg" variant = 'outline-primary'  tag="router-link" :to="{ path: '/inventory' }"><font-awesome-icon icon="warehouse" /> Inventory</b-button>
                            </div>
                        </b-col>
                    </b-row>
                    <!-- Reps -->
                    <b-row>
                        <b-col>
                            <div style="text-align:center; margin-top:20px">
                                <b-button size="lg" variant = 'outline-info'  tag="router-link" :to="{ path: '/managereps' }"><font-awesome-icon icon="user-friends" /> Manage Reps</b-button>
                            </div>
                        </b-col>
                    </b-row>

                    <!-- Trading Post -->
                    <!--
                    <b-row>
                        <b-col>
                            <div style="text-align:center; margin-top:20px; color:#808080">
                                <h6>Need To Buy Something?</h6>
                            </div>
                            <div style="text-align:center; margin-top:0px">
                                <b-button size="lg" variant = 'outline-primary'  tag="router-link" :to="{ path: '/tradingpost' }"><font-awesome-icon icon="shuttle-van" /> Keg Seeker Trading Post</b-button>
                            </div>
                        </b-col>
                    </b-row>
                    -->

                    <!-- Help -->
                    <div style="text-align:center; margin-top:20px; color:#808080">
                        <h6>Need Help?</h6>
                    </div>

                    <!-- Help -->
                    <b-row>
                        <b-col>
                            <div style="text-align:center; margin-top:0px">
                                <b-button variant = 'outline-dark'  tag="router-link" :to="{ path: '/contact' }"><font-awesome-icon icon="question" /> Contact Keg Seeker</b-button>
                            </div>
                        </b-col>
                    </b-row>

                </b-col>
                <!-- Right colums for Marketing -->
                <b-col>
                    <Marketing />
                </b-col>
            </b-row>

            <b-row v-if='!userProfile.logoUploaded'>
                <b-col>
                    <i>You have not uploaded a logo yet. Please go to</i><router-link to="settings" > SETTINGS</router-link> to add your logo
                    <hr>
                </b-col>
            </b-row>
            <b-row v-if='!userProfile.description'>
                <b-col>
                    <i>You can also say something about your brewery in the "About your brewery" section of</i><router-link to="settings" > SETTINGS</router-link>
                    <hr>
                </b-col>
            </b-row>
            <hr v-if='!userProfile.description'>
            
            <hr>
            <b-row v-if='!userProfile.licenseUploaded'>
                <b-col>
                    <i>You have not uploaded a brewers license file yet. Go to</i><router-link to="settings" > SETTINGS</router-link> to add your license file
                </b-col>
            </b-row>
        </b-container>
        <footer><pagefooter/></footer>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { currentUser } from '../firebaseConfig'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')
    import Pagefooter from './Pagefooter'
    import Sendmessage from './Sendmessage'
    import Marketing from './seller/Marketing'


    export default {
    components: {
            Pagefooter,
            Sendmessage,
            Marketing,
        },

        data() {
            return {  
                buyersList:[],   
                gettingBuyersList:false,   
                arrayDefaultMessages:[],      

            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser', 'unreadCount', 'newBreweryOrdersCount', 'deliverSoonCount', 
            'newsFeed', 'dataLoadingInStoreStatus', 'allowAdvertising', 'openServiceRequests']),
            getBrewerURL(){
                return 'https://kegseeker.com/#/brewers/'+this.userProfile.shortName
            }
        },
        watch: {
            dataLoadingInStoreStatus(newValue, oldValue) {
            },
        },

        methods: {
            showOrders(){
                this.$router.push({name:'brewerorders'})
            },
            showServiceRequests(){
                this.$router.push({path:'/sellerservicerequests'})
            },

            showMessages(){
                this.$router.push({name:'messagesholder'})

            },

            goToComposeEmail(){
                this.$router.push({name:'selectcountiesforemail'})
            },

            //Clipboard success
            clipboardSuccessHandler(){
                this.$bvToast.toast('Copied to clipboard', {
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
            },

            //Get buyers
            getBuyers(){
                this.gettingBuyersList=true
                this.buyersList = []
                var buyersArray=[]
                fb.usersCollection.where("county", "in", this.userProfile.counties).where("state", "==", this.userProfile.state).where("isbrewer", "==", 0).get().then(docs => {
                    docs.forEach(doc => {
                        var theBuyerData = doc.data()
                        var theBuyerId = doc.id
                        var theBuyerName = theBuyerData.company
                        var theBuyerEmail = theBuyerData.email
                        var theBuyerUid = theBuyerData.uid
                        //Create address
                        var address = theBuyerData.street1
                        if (theBuyerData.street2) address = address + ", " + theBuyerData.street2
                        address = address + ", " + theBuyerData.city + ', ' + theBuyerData.state  + " "  + theBuyerData.zip 
                        var buyerObject = {
                            company: theBuyerName,
                            email: theBuyerEmail,
                            uid: theBuyerId,
                            selected:true,
                            address:address,
                        }
                        buyersArray.push(buyerObject)

                        })
                    }).then(res => {
                        this.buyersList = buyersArray
                        this.gettingBuyersList=false
                        this.$bvModal.show("buyers")
                        })
                        .catch(err => {
                            console.log(err)
                            this.gettingBuyersList=false
                    })
            },

        },
        
    }
</script>